<style scoped lang="css">
@media (min-width: 576px) {
  .card {
    min-height: 160px;
  }
}

@media (min-width: 768px) {
  .card {
    min-height: 200px;
  }
}

@media (min-width: 992px) {
  .card {
    min-height: 180px;
  }
}

@media (min-width: 1200px) {
  .card {
    min-height: 200px;
  }
}
</style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-sm--hover mb-3">
        <Header title="Contactos" />
        <b-row class="mb-3">
          <b-col cols="12" class="mb-3">
            <b-button variant="default" size="sm" @click="goBack">
              <b-icon-chevron-left scale="1.2"></b-icon-chevron-left>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3 px-3">
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm">
              <b-card-title>
                Chihuahua, Chihuahua
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Tel&eacute;fonos:
                  <a href="tel:+526144403119">(614) 440-3119</a> y
                  <a href="tel:+526142000291">(614) 200-0291</a>
                </p>
                <p>
                  Emergencias: <a href="tel:+526142458642">(614) 245-8642</a>
                </p>
                <p>
                  Correo electr&oacute;nico:
                  <a href="mailto:contacto@tknoroeste.com"
                    >contacto@tknoroeste.com</a
                  >
                </p>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm">
              <b-card-title>
                Cd. J&uacute;arez, Chihuahua
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Tel&eacute;fono:
                  <a href="tel:+526561238623">(656) 123-8623</a>
                </p>
                <p>
                  Servicio <em>24/7</em>:
                  <a href="tel:+526563367518">(656) 336-7518</a>
                </p>
                <p>
                  Correo electr&oacute;nico:
                  <a href="mailto:contacto@tknoroeste.com"
                    >contacto@tknoroeste.com</a
                  >
                </p>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm">
              <b-card-title>
                Hermosillo, Sonora
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Tel&eacute;fono:
                  <a href="tel:+526622610363">(662) 261-0363</a>
                </p>
                <p>
                  Servicio <em>24/7</em>:
                  <a href="tel:+526622610363">(662) 261-0363</a>
                </p>
                <p>
                  Correo electr&oacute;nico:
                  <a href="mailto:contacto@tknoroeste.com"
                    >contacto@tknoroeste.com</a
                  >
                </p>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <b-card class="shadow-sm">
              <b-card-title>
                Mexicali, Baja California
              </b-card-title>
              <b-card-text class="text-center">
                <p>
                  Tel&eacute;fono:
                  <a href="tel:+526862629216">(686) 262-9216</a>
                </p>
                <p>
                  Servicio <em>24/7</em>:
                  <a href="tel:+526865614720">(686) 561-4720</a>
                </p>
                <p>
                  Correo electr&oacute;nico:
                  <a href="mailto:contacto@tknoroeste.com"
                    >contacto@tknoroeste.com</a
                  >
                </p>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <Footer />
      </main>
    </section>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";

export default {
  name: "Contacts",
  components: {
    Header,
    Footer,
  },
  methods: {
    goBack() {
      this.$router.push("/");
    },
  },
};
</script>
